import { Injectable, NgZone } from '@angular/core';

import { SyncMessenger } from '../helpers/sync-messenger';

import { ANGULAR_SERVICE_WORKER_MESSAGE_TYPES } from '../constants/angular-messaging.constants';
import { APP_DATA_KEYS } from '../constants/app-data.constants';
import { LogLevel } from '../constants/log.constants';

import { AppDataService } from './app-data.service';

@Injectable({
  providedIn: 'root'
})
export class SyncMessengerService {

  private syncMessenger: SyncMessenger;

  constructor(
    ngZone: NgZone,
    appDataService: AppDataService) {

    const logLevel = appDataService.getAppData<LogLevel>(APP_DATA_KEYS.logLevel);
    this.syncMessenger = new SyncMessenger(ngZone, ANGULAR_SERVICE_WORKER_MESSAGE_TYPES.success, logLevel);
  }

  getSyncMessenger(): SyncMessenger {
    return this.syncMessenger;
  } 
}
